<template>
  <div>
    <el-row>
      <div style="width: 22%; height: 85vh; overflow:scroll;float:left;">
        <el-tree
            style="margin: 10px 10px 20px 0px; width: 340px;"
            :data="faultGroup"
            :props="defaultProps"
            node-key="id"
            default-expand-all
            :expand-on-click-node="false">
          <span slot-scope="{ node, data }" class="custom-tree-node">
            <span>{{node.label}}</span>
            <span>
              <el-button
                  style="margin-left: 10px;"
                  type="text"
                  icon="el-icon-circle-plus"
                  @click="append(data)"/>
              <el-button
                  v-if="data.id !== 0"
                  type="text"
                  icon="el-icon-edit"
                  @click="edit(node, data)"/>
              <el-button
                  v-if="data.id !== 0"
                  type="text"
                  icon="el-icon-delete"
                  @click="remove(data)"/>
            </span>
          </span>
        </el-tree>
        <fault-group-edit ref="faultGroupEditPage" @save-success="getFaultGroup()"/>
      </div>
      <div style="float:right; width: 77%;">
        <vm-table
            ref="vmTable"
            height="65vh"
            :filter.sync="filter"
            module="basic"
            url="faultInfoes"
            @select="selectTest">
          <el-button
              slot="toolbar"
              type="primary"
              size="mini"
              @click="$refs.faultEditPage.open()">
            新增
          </el-button>
          <template slot="adSearch">
            <div class="vm-search">
              <vm-search label="关键词">
                <el-input v-model.trim="filter.filter" clearable/>
              </vm-search>
            </div>
          </template>
          <el-table-column prop="groupName" label="故障类型"/>
          <el-table-column prop="faultCode" label="故障代码"/>
          <el-table-column prop="faultDesc" label="故障描述"/>
          <el-table-column
              label="操作"
              align="center"
              class-name="vm-table_operate"
              width="180px">
            <template slot-scope="scope">
              <el-button @click="$refs.faultGuidancePage.open(scope.row.id)">故障指导</el-button>
              <el-button type="primary" @click="$refs.faultEditPage.open(scope.row)">编辑</el-button>
              <el-button type="danger" @click="deleteRow(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </vm-table>
        <fault-edit ref="faultEditPage" @save-success="getList(-1)"/>
        <fault-guidance-list ref="faultGuidancePage"/>
      </div>
    </el-row>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import FaultGroupEdit from "@/views/information/Fault/FaultGroupEdit.vue";
  import FaultEdit from "@/views/information/Fault/FaultEdit.vue";
  import FaultGuidanceList from "@/views/information/Fault/FaultGuidanceList.vue";

  export default {
    name:"Fault",
    components: {VmTable, VmSearch, FaultGroupEdit, FaultEdit, FaultGuidanceList},
    data() {
      return {
        faultGroup: [{
          id: 0,
          name: "全部",
          parentID: 0,
          children: [],
        }],
        defaultProps: {
          children: "children",
          label: "name",
        },
        idList: "",
        filter: {
          filter: "",
        },
      };
    },
    mounted() {
      this.getFaultGroup();
      this.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      deleteRow(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic","/faultInfoes", row.id).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
        });
      },
      getFaultGroup() {
        this.$http
          .get("basic","faultGroups").then((res) => {
            if (res) {
              this.faultGroup[0].children = JSON.parse(JSON.stringify(res));
            } else {
              this.$message.error("获取数据出错");
            }
          });
      },
      append(data) {
        if (data.id == 0)
          this.$refs.faultGroupEditPage.open(null, null, null, 1);
        else
          this.$refs.faultGroupEditPage.open(data.id, null, null, 0);
      },
      edit(node, data) {
        this.$refs.faultGroupEditPage.open(node.parent.data.id, data.id, data.name, 0);
      },
      remove(data) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic","faultGroups", data.id).then(() => {
            this.getFaultGroup();
            this.$message.success("删除成功");
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .custom-tree-node {
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
</style>
